import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { getBreakpointFromManor } from 'ctm-components';
import { ThemeContext } from 'styled-components';
import { TableRow, TableCell } from '@comparethemarketau/manor-table';

const useStyles = createUseStyles((theme) => ({
    cell: {
        ':first-child': {
            border: 'none'
        },
        extend: ({ breakpoint }) => {
            switch (breakpoint) {
                case 'lg':
                case 'md':
                    return {
                        padding: '1.4rem 1.6rem',
                        borderLeft: `0.2rem solid ${theme.colors.grey300}`
                    };
                default:
                    return {
                        padding: '1.1rem 1.1rem',
                        borderLeft: `0.1rem solid ${theme.colors.grey300}`
                    };
            }
        }
    },
    row: {
        padding: '0',
        background: theme.colors.white,
        extend: ({ breakpoint }) => {
            switch (breakpoint) {
                case 'lg':
                case 'md':
                    return {
                        fontSize: theme.fontSize.base,
                        border: `0.2rem solid ${theme.colors.grey300}`
                    };
                default:
                    return {
                        fontSize: theme.fontSize.sm,
                        border: `${theme.spacing.px} solid ${theme.colors.grey300}`
                    };
            }
        }
    },
    title: {
        fontWeight: theme.fontWeight.semibold,
        padding: theme.spacing[16]
    }
}));

const ProductTableRow = (props) => {
    const { stackDisplayMode, columnCount, cells, title, cellClassName, hidden } = props;
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });
    return !hidden && (
        <>
            {stackDisplayMode && (
                <TableRow className={classes.row}>
                    <TableCell colspan={columnCount}>{title}</TableCell>
                </TableRow>
            )}
            <TableRow className={classes.row}>
                {!stackDisplayMode && (
                    <TableCell className={classes.title}>{title}</TableCell>
                )}
                {cells.map((cell) => {
                    return (
                        <TableCell
                            key={cell.key}
                            className={classNames(cellClassName, classes.cell)}
                        >
                            {cell}
                        </TableCell>
                    );
                })}
            </TableRow>
        </>
    );
};

ProductTableRow.propTypes = {
    title: PropTypes.string,
    cells: PropTypes.object,
    stackDisplayMode: PropTypes.bool,
    columnCount: PropTypes.number,
    cellClassName: PropTypes.string,
    hidden: PropTypes.bool
};

export { ProductTableRow };
